import { createRouter, createWebHistory } from 'vue-router';

import Initial from '../views/legacy/Initial.vue';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'initial',
      component: Initial
    },
    {
      path: '/gps-error',
      name: 'gps-error',
      component: () => import('../views/legacy/NoGpsAvailable.vue')
    },
    {
      path: '/appointment-error',
      name: 'appointment-error',
      props: route => ({ ...route.query }),
      component: () => import('../views/legacy/ErrorScreen.vue')
    },
    {
      path: '/warehouse-error',
      name: 'warehouse-error',
      props: route => ({ ...route.query }),
      component: () => import('../views/legacy/ErrorScreen.vue')
    },
    {
      path: '/rejected-check-in',
      name: 'rejected-check-in',
      component: () => import('../views/legacy/RejectedCheckin.vue')
    },
    {
      path: '/completed',
      name: 'completed',
      props: route => ({ ...route.query }),
      component: () => import('../views/legacy/Completed.vue')
    },
    {
      path: '/verification-error',
      name: 'verification-error',
      props: route => ({ ...route.query }),
      component: () => import('../views/legacy/ErrorScreen.vue')
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: () => import('../views/NotFound.vue')
    }
  ]
});

export default router;
